import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import severUrl from "../../api";
import pdfm from "../../assets/svgs/pdf.svg";
import youtube from "../../assets/svgs/youtube.svg";
import { HtmlBody } from "./HtmlBody";
import { HTML } from "./html";
import { MathComponent } from "mathjax-react";
import { TABLE } from "./table";
import Prism from "prismjs";
import "../../assets/css/prism.css";
import "../../assets/css/post.css";
// import "../../assets/css/text.css";
// import "../../assets/css/newfull.css";
import cmd from "../../assets/images/cmd.png";
import "prismjs/components/prism-python";
import ReactDOMServer from "react-dom/server";
import parse from "html-react-parser";
import { BlinkBlur } from "react-loading-indicators";
import ReactHtmlParser from 'html-react-parser';
import { copyText, extractCodeContent } from '../Utils/utils';
import { Tooltip as ReactTooltip } from "react-tooltip";
import mic from "../../assets/images/mic.png"
import crewai from "../../assets/images/crewai.png"


import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import Model from "./Video";
import MLModel from "./MLModel";

import GoogleAd from "../Adsense/GoogleAd";

const options = { //Typescript ways of adding the type
  year: "numeric",
  month: "long",
};

const DATE_OPTIONS = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };


function AsyncCall() {
  return new Promise((resolve) => setTimeout(() => resolve(), 2500));
}

export const MobilePost = (props) => {

  const [created_on, set_created_on] = useState('');
  const [title, set_title] = useState('');
  const [slug, set_slug] = useState('');
  const [updated_on, set_updated_on] = useState('');
  const [status, set_status] = useState('');
  const [appendix, set_appendix] = useState('');
  const [text, set_text] = useState('');
  const [styles, set_styles] = useState('');
  const [citation, set_citation] = useState('');
  const [views, set_views] = useState('');
  const [eng_ver, set_eng_ver] = useState('');
  const [lang, set_lang] = useState('');
  const [pdf, set_pdf] = useState('');
  const [video, set_video] = useState('');
  const [previous, set_previous] = useState('');
  const [next, set_next] = useState('');
  const [previous_title, set_previous_title] = useState('');
  const [next_title, set_next_title] = useState('');
  const [loading, set_loading] = useState(true);
  const [counter, set_counter] = useState('');
  const [readyToTypeset, set_readyToTypeset] = useState(false);
  const [features, set_features] = useState([]);
  const [authors, set_authors] = useState([]);
  const [modelLink, set_modelLink] = useState('');
  const [html, set_html] = useState("");
  const [currVer, set_currVer] = useState(1.0);
  const [modelShow, set_modelShow] = useState(false);
  const [fvalues, set_fvalues] = useState([]);
  const [predictValue, set_predictValue] = useState('');
  const [MLModelShow, set_MLModelShow] = useState(false);
  const [apiError, setApiError] = useState(false);
  

  const mathjaxConfig = {
    startup: {
      ready: () => {
        window.MathJax.startup.defaultReady();
        this.setState({ readyToTypeset: true });
      },
    }

  };

  const mounted = useRef();

  useEffect(() => {

    window.MathJax = mathjaxConfig;

    let script = document.createElement("script");
    script.defer = true;
    script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
    document.head.appendChild(script);

    if (!mounted.current) {
      // do componentDidMount logic
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
      if (readyToTypeset) {
        window.MathJax.typesetPromise();
      }

      Prism.highlightAll();

    }

  });


  useEffect(() => {
    counter > 0 &&
      setTimeout(
        () => set_counter(counter - 1),
        1000
      );
    fetch(severUrl + `blog/${props.data.slug}/`, {
      method: "GET",
      ContentEncoding: "gzip",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.html) {
          props.sendDataToParent()
          set_loading(false)
          set_html(data.html.content)
          set_counter(0)
          set_created_on(new Date(data.post.created_on).toLocaleDateString([], options))
          set_title(data.post.title)
          set_views(data.post.total_visited)
          set_lang(data.post.lang)
          set_eng_ver(data.post.eng_ver)
          set_pdf(data.post.pdf)
          set_video(data.post.video)
          set_modelLink(data.post.modelLink)
          set_features(data.post.features)
          set_authors(data.post.authors)
          if (data.post.previous_post !== null) {
            set_previous_title(data.post.previous_post.title)
            set_previous(data.post.previous_post.slug)
          }
          if (data.post.next_post !== null) {
            set_next(data.post.next_post.slug)
            set_next_title(data.post.next_post.title)
          }
          const v = [];
          if (data.post.features) {
            for (let i = 0; i < data.post.features.length; i++) {
              v.push({ id: i, value: 0 });
            }
            set_fvalues(v)
          }
        } else {
          AsyncCall().then(() => {
            set_loading(false);
            set_counter(0);
            // set_content(data.content);
            set_created_on(data.post.created_on);
            set_title(data.post.title);
            set_views(data.post.total_visited);
            set_lang(data.post.lang);
            set_eng_ver(data.post.eng_ver);
            set_appendix(data.appendix);
            set_text(data.text);
            set_citation(data.citation);
            set_styles(data.styles);
            set_pdf(data.post.pdf);
            set_video(data.post.video);
            set_modelLink(data.post.modelLink);
            set_features(data.post.features);
            if (data.post.previous_post !== null) {
              set_previous_title(data.post.previous_post.title);
              set_previous(data.post.previous_post.slug);
            }
            if (data.post.next_post !== null) {
              set_next(data.post.next_post.slug);
              set_next_title(data.post.next_post.title);
            }
            const v = [];
            if (data.post.features) {
              for (let i = 0; i < data.post.features.length; i++) {
                v.push({ id: i, value: 0 });
              }
              set_fvalues(v);
            }
          })
        }
      }).catch((error) => {
        setApiError(true)
      })
  }, []);


  const onShow = () => {
    set_modelShow(!modelShow)
    document.body.style.overflow = !modelShow ? "hidden" : "scroll";
  }

  const onMLShow = () => {
    set_MLModelShow(!MLModelShow);
    document.body.style.overflow = !MLModelShow
      ? "hidden"
      : "scroll";
  }

  const changeVersion = async () => { }

  const handleCopy = async (step) => {
    try {
      const insideCodeTag = extractCodeContent(html)[step];
      console.log(insideCodeTag);
      await copyText(insideCodeTag);
      // setStatus(`Step ${step + 1} Copied!`);
    } catch (error) {
      // setStatus(error.message);
      console.log("error copy")
    }
  };

  const replace = (domNode) => {
    if (
      domNode.name === 'button' &&
      domNode.attribs.id?.startsWith('copy_button_')
      // Id bắt đầu bằng testButton_, số đầu là 0 (testButton_0)
    ) {
      const buttonIndex = parseInt(domNode.attribs.id.split('_')[2], 10);
      console.log(domNode.attribs.id.split('_')[2])
      return (
        <button onClick={() => handleCopy(buttonIndex)}>
          {domNode.children[0]?.data || 'Button'}
        </button>
      );
    }
  };

  const options = {
    replace,
  };


  return (<>
    {modelShow && <Model hide={onShow} link={video} />}
    {MLModelShow && (
      <MLModel
        hide={onMLShow}
        link={modelLink}
        features={features}
      />
    )}
    <div data-v-535cd656 className="title">
      {(previous || next) && (
        <div
          style={{
            alignItems: "center",
            marginBottom: "0px",
            width: "100%",
            paddingBottom: "40px",
            marginTop: "40px",
            height: "80px",
            display: "flex",
            flexDirection: "row",
            fontSize: "1rem",
            fontWeight: "450",
          }}
        >
          {previous && (
            <a
              style={{
                width: "50%",
                alignItems: "start",
                alignContent: "start",
                textAlign: "start",
                color: "rgb(14, 103, 212)",
                fontSize:"12px"
              }}
              href={"/" + previous}
            >
              {previous_title}
            </a>
          )}
          {next && (
            <a
              style={{
                width: "50%",
                alignItems: "end",
                alignContent: "end",
                textAlign: "end",
                color: "rgb(14, 103, 212)",
                fontSize:"12px"
              }}
              href={"/" + next}
            >
              <p>{next_title}</p>
            </a>
          )}
        </div>
      )}
      <div
        style={{
          fontSize: "calc(12px + .390625vw)",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          margin: "1rem 0 0 0",
          paddingTop:"1rem"
        }}
      >
        {(new Date(created_on)).toLocaleDateString('en-US', DATE_OPTIONS)}
      </div>
      <h1 data-v-fa32733e className="title">
        <span data-v-5bf7a092 data-v-fa32733e >{title}</span>
      </h1>
      {authors.length != 0 && <p style={{ marginTop: "20px", fontWeight: "480" }}>{'Helped by: ' + authors}</p>}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          textAlign: "center",
          paddingTop: "1em",
          paddingBottom: "1em",
          // marginBottom: "20px",
        }}
      >
        {severUrl === "http://127.0.0.1:8000/" && (
          <>
            <a
              style={{ width: "20px", margin: "0 10px 0 10px" }}
              href={"http://127.0.0.1:8000/" + pdf}
            >
              <img alt="pdf file" src={pdfm}></img>
            </a>
            <button label="u" onClick={onShow}>
              <img
                alt="Video link"
                style={{
                  height: "20px",
                  border: "none",
                  backgroundColor: "transparent",
                  margin: "0 10px 0 10px",
                }}
                src={youtube}
              ></img>
            </button>
          </>
        )}

        {severUrl !== "http://127.0.0.1:8000/" && (
          <>
            <a href={pdf}>
              <img alt="pdf file"
                style={{ width: "25px", marginRight: "5px" }}
                src={pdfm}
              ></img>
            </a>
            <button
              style={{
                height: "40px",
                border: "none",
                backgroundColor: "transparent",
              }}
              onClick={onShow}
            >
              <img
                alt="Youtube link"
                style={{
                  width: "25px",
                  border: "none",
                  backgroundColor: "transparent",
                }}
                src={youtube}
              ></img>
            </button>

          <div style={{fontSize:"12px"}} data-tooltip-id="my-tooltip-2">chat GPT</div>
          <a>
            <img alt="read"               
            style={{
                width: "25px",
                border: "none",
                backgroundColor: "transparent",
              }}
              src={mic}></img>
          </a>
          <ReactTooltip
            id="my-tooltip-2"
            place="bottom"
            content="Feature In progess"
          />

          <div style={{fontSize:"12px", paddingLeft:"5px", paddingRight:"5px"}} data-tooltip-id="my-tooltip-6">Summerize with crewAi</div>
          <a>
            <img alt="read"               
            style={{
                width: "25px",
                border: "none",
                backgroundColor: "transparent",
              }}
              src={crewai}></img>
          </a>
          <ReactTooltip
            id="my-tooltip-6"
            place="bottom"
            content="Feature In progess"
          />

          </>
        )}

        {modelLink !== "" && modelLink && (
          <>
            <button
              label="commsndBtn"
              style={{
                width: "25px",
                border: "none",
                backgroundColor: "transparent",
                margin: "0 10px 0 10px",
              }}
              onClick={onMLShow}
            >
              <img
                alt="Command"
                style={{
                  maxWidth: "25px",
                  border: "none",
                  backgroundColor: "transparent",
                }}
                src={cmd}
              ></img>
            </button>
          </>
        )}
        {eng_ver && (
          <button
            onClick={changeVersion}
            style={{
              width: "fit-content",
              margin: "10px",
              marginBottom: "20px",
            }}
          >
            {lang === 0 ? "Read ENG" : "Read VIE"}
          </button>
        )}
      </div></div>
    {ReactHtmlParser(html, options)}


  </>)

}